import { render, staticRenderFns } from "./VueNestableHandle.vue?vue&type=template&id=07431224"
import script from "./VueNestableHandle.vue?vue&type=script&lang=js"
export * from "./VueNestableHandle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports